import { isInIframe } from './iframeDetector';
/**
 * Creates a hook for axios cookie interceptor to post the token to parent window.
 *
 * @param allowOrigin
 *   Which origins should be allowed to receive this message.
 */
var createPostMessageTokenHook = function (allowOrigin) {
    if (!allowOrigin || allowOrigin === '*') {
        throw new Error("You must provide explicitly allowed origin for the token message.");
    }
    return function (token) {
        if (isInIframe()) {
            window.parent.postMessage({
                type: 'session_token',
                token: token,
            }, allowOrigin);
        }
    };
};
export default createPostMessageTokenHook;
//# sourceMappingURL=createPostMessageTokenHook.js.map